import { GtmEvents } from '@/gtm/gtm-events';

export class BannersGtmEvents extends GtmEvents {
  eventCategory = 'СобытияБаннеры';

  showBanner({
    slotName, hostUrl, redirectUrl, imageUrl, index,
  }) {
    return this.gtmEvent({
      eventAction: `БаннерПоказ_${slotName}`,
      eventLabel: this._getBannerEventLabel({
        imageUrl, hostUrl, redirectUrl, index,
      }),
    });
  }

  clickBanner({
    slotName, text, hostUrl, redirectUrl, imageUrl, index,
  }) {
    return this.gtmEvent({
      eventAction: `БаннерКлик_${slotName}_${text || 'Баннер'}`,
      eventLabel: this._getBannerEventLabel({
        imageUrl, hostUrl, redirectUrl, index,
      }),
    });
  }

  showClpBanner(data) {
    return this.gtmEvent({
      eventAction: 'БаннерПоказ',
      eventLabel: JSON.stringify(data),
    });
  }

  clickClpBanner(data) {
    return this.gtmEvent({
      eventAction: 'БаннерКлик',
      eventLabel: JSON.stringify(data),
    });
  }

  _getBannerEventLabel({
    imageUrl, hostUrl, redirectUrl, index,
  }) {
    const currentPage = window?.location?.pathname;

    const eventLabel = [
      imageUrl,
      `${hostUrl || currentPage}-->${redirectUrl || currentPage}`,
    ];

    // eslint-disable-next-line no-unused-expressions
    index !== null && eventLabel.push(index + 1);

    return eventLabel.join('|');
  }
}

export const bannersGtmEvents = new BannersGtmEvents();
